import styled from 'styled-components';

export const MessageLabel = styled.div`
  background: #66cc00;
  color: white;
  font-weight: bold;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 12px;
  margin: 0.5rem 0;
`;

export const DisabledAction = styled.p`
  color: #71757b;
  text-decoration: underline;
`;

export const MessageMain = styled.div`
  display: flex;
  flex-direction: column;
`;
